import {DomainEvent} from './DomainEvent';
import {Match} from '../resources/Match';

export class LiveTickerMatchResultUpdated extends DomainEvent<Match> {}
